"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/card/style");
var _card = _interopRequireDefault(require("antd/lib/card"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireWildcard(require("react"));
require("./RelatedGroups.less");
var _uuid = _interopRequireDefault(require("uuid"));
var _api = require("./api");
var _RelatedGroupForm = _interopRequireDefault(require("./RelatedGroupForm"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Title = _typography.default.Title;
var RelatedGroups = function RelatedGroups(_ref) {
  var group = _ref.group;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    relatedGroups = _useState2[0],
    setRelatedGroups = _useState2[1];
  var _useFetchGroups = (0, _api.useFetchGroups)(),
    groups = _useFetchGroups.groups,
    loadingGroups = _useFetchGroups.loadingGroups;
  var _useUpdateRelatedGrou = (0, _api.useUpdateRelatedGroups)(),
    handleRelatedGroupsSubmit = _useUpdateRelatedGrou.handleSubmit,
    processing = _useUpdateRelatedGrou.processing;
  var filteredGroups = groups.filter(function (item) {
    return item.id !== group.id;
  });
  (0, _react.useEffect)(function () {
    if (!group.id) {
      return;
    }
    var relGroups = group.relatedGroups.map(function (item) {
      return {
        id: item.relatedGroup.id,
        name: item.relatedGroup.name
      };
    });
    setRelatedGroups(relGroups);
  }, [group]);
  var handleAddRelatedGroup = function handleAddRelatedGroup() {
    var newRelatedGroups = [].concat(_toConsumableArray(relatedGroups), [{
      id: (0, _uuid.default)(),
      name: ''
    }]);
    setRelatedGroups(newRelatedGroups);
  };
  var handleRemoveRelatedGroup = function handleRemoveRelatedGroup(groupId) {
    var newRelatedGroups = relatedGroups.filter(function (item) {
      return item.id !== groupId;
    });
    setRelatedGroups(newRelatedGroups);
  };
  var handleSelectChange = function handleSelectChange(value, index) {
    var relatedGroup = groups.find(function (group) {
      return group.id === value;
    });
    var newRelatedGroups = _toConsumableArray(relatedGroups);
    newRelatedGroups[index] = relatedGroup;
    setRelatedGroups(newRelatedGroups);
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return handleRelatedGroupsSubmit({
                groupId: group.id,
                values: values
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loadingGroups || processing
  }, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    md: 12,
    className: "mb-30 flex"
  }, /*#__PURE__*/_react.default.createElement(_card.default, {
    className: "custom-card ant-card-shadow ant-card-narrow flex-grow",
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 4
    }, "Related Groups"),
    bordered: false
  }, /*#__PURE__*/_react.default.createElement(_RelatedGroupForm.default, {
    relatedGroups: relatedGroups,
    groups: filteredGroups,
    onAddRelatedGroup: handleAddRelatedGroup,
    onRemoveRelatedGroup: handleRemoveRelatedGroup,
    onSelectChange: handleSelectChange,
    onSubmit: handleSubmit
  })))));
};
var _default = RelatedGroups;
exports.default = _default;